import { Header, Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import importReportOutcomes from "astrid-firestore/src/api/imports/constants/importReportOutcomes";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import Accordion from "../../../ui/components/Accordion/Accordion";
import ErrorMessage from "../../../ui/components/Messages/ErrorMessage";

export default function ImportReports({ importt }) {
	const { t } = useTranslation();

	const [reports, loading, error] = useCollectionData(
		importt.ref.collection("reports").orderBy("reportTime", "desc"),
	);

	const outcomes = {
		[importReportOutcomes.APPLIED]: t("applied", "Applied"),
		[importReportOutcomes.OLDER]: t("skippedOlderReport", "Skipped, older than the imported data"),
		[importReportOutcomes.NOT_DRAFT]: t("skippedNotDraft", "Skipped, the edition is no longer a draft"),
	};

	if (error) {
		return <ErrorMessage error={error} />;
	}

	if (loading || !reports.length) {
		return null;
	}

	return (
		<>
			<Header as="h3">{t("reports", "Reports")}</Header>

			<Accordion
				panels={reports.map(({ id, file, reportTime, outcome, rows }) => ({
					key: id,
					title: [
						new Date(reportTime).toLocaleString(),
						file,
						outcomes[outcome] || t("beforeHistory", "Recorded before history was kept"),
					].join(" · "),
					content: {
						content: (
							<Segment inverted style={{ overflowX: "auto" }}>
								<pre>{JSON.stringify(JSON.parse(rows), null, 2)}</pre>
							</Segment>
						),
					},
				}))}
			/>
		</>
	);
}
